module.exports = __webpack_public_path__ + "img/ewm.be9d0b78.jpg";